import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useInView } from 'framer-motion';
import '../styles/CertificatesSection.css';

const Home = () => {
  const { t } = useTranslation();
  const certificatesRef = useRef(null);
  const certificatesInView = useInView(certificatesRef, { once: true, margin: '-100px 0px' });
  return (
    <>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, ease: 'easeOut' }}
        style={{ margin: '2.5rem 0', textAlign: 'center', lineHeight: 1.25, maxWidth: 900, marginLeft: 'auto', marginRight: 'auto', justifyContent: 'center', maxWidth: '90%' }}
      >
        <h1 style={{ fontSize: '3rem', fontWeight: 800, color: '#fefaf0', marginBottom: '1.25rem', overflowWrap: 'break-word', hyphens: 'auto' }}>
          {t('home.heroTextHeader')}
        </h1>
        <p style={{ fontSize: '1.5rem', fontWeight: 500, color: '#fefaf0', maxWidth: '75%', margin: '0 auto' }}>
          {t('home.heroText')}
        </p>
      </motion.div>
      <div className="certificates-section-container">
        <div ref={certificatesRef} style={{ minHeight: '1px' }} />
        {certificatesInView && (
          <motion.div
            className="certificatesSection"
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            style={{
              width: '100%',
              background: '#222',
              color: '#fff',
              textAlign: 'center',
              padding: '2.5rem 1rem',
              margin: '2.5rem 0',
              boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
            }}
          >
            <h2 style={{ color: '#fbfbec', marginBottom: 18, fontSize: '2.3rem', fontWeight: 700 }}>{t('home.certificatesHeader')}</h2>
            <div className="certificates-images-wrapper" style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap' }}>
              <motion.img
                src={require('../images/cert1.png')}
                alt="Certificate 1"
                className="certificate-image"
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: 'easeOut' }}
              />
              <motion.img
                src={require('../images/cert2.png')}
                alt="Certificate 2"
                className="certificate-image"
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: 'easeOut', delay: 0.15 }}
              />
              <motion.img
                src={require('../images/cert3.png')}
                alt="Certificate 3"
                className="certificate-image"
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: 'easeOut', delay: 0.3 }}
              />
              <motion.img
                src={require('../images/cert4.png')}
                alt="Certificate 4"
                className="certificate-image"
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: 'easeOut', delay: 0.45 }}
              />
            </div>
          </motion.div>
        )}
      </div>
    </>
  );
};

export default Home;
